var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"buc__lightbox-cont"}},[_c('div',{staticClass:"buc__lightbox",on:{"click":_vm.close}},[_c('span',{staticClass:"buc__lightbox-close",on:{"click":_vm.close}},[_vm._v("×")]),_c('img',{attrs:{"src":_vm.imageSrc}})])])}
var staticRenderFns = []

export { render, staticRenderFns }